import BarChart from "echarts-for-react";
import { useEffect, useState } from "react";
import { addOnChangeHook, deleteOnChangeHook } from "../../BackgroundPoller";
interface Props {
  color: string
}

function add15minutes(date : Date) : Date {
  //+15 minutes or 900000 ms (use double subtraction to add because JS is JS)
  return new Date(date-(-900000));
}

export default function TrafficGraph(props: Props) {
  const [currentDate, setCurrentDate] = useState(new Date);
  const [blink, setBlink] = useState(false); // This is not a very good way to animate, but it will do for now

  const updateHook = () => {
    setCurrentDate(new Date());
  }

  useEffect(() => {
        addOnChangeHook(updateHook)
        //const blinker = setInterval(() => {setBlink(!blink)},500)
        return () => {
          deleteOnChangeHook(updateHook);
          //clearInterval(blinker)
        }
  });

  let option = {
    color: [props.color],

    grid: {
      top: 20,
      bottom: 50,
      left: 10,
      right: 10
    },

    textStyle: {
      color: props.color
    },

    xAxis: {
      type: 'category',
      axisTick: {
        interval: 0
      },
      axisLabel: {
        interval : 'auto'
      }
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        show : false
      }
    },
    series: [
      {
        data: [] as Record<string, any>[],
        type: 'bar',
      }
    ]
  };

  const highlightOption = {
    'label': { 
      show: true, 
      position: 'top',
      fontSize: "20",
      formatter:'▼',
      color: blink ? "#f30" : props.color
    },

    'itemStyle': {
      'decal': {
        color: props.color == "#fff" ? "#1a2235" : "#fff",
         dashArrayX: [1, 0],
         dashArrayY: [3, 6],
         symbolSize: 1,
         rotation: Math.PI / 6}
        }
      ,
  }

  const sampleData = [3, 8, 14, 10, 21, 27, 31, 27, 17, 13, 10, 6, 4, 3, 2, 1];
  const lent = sampleData.length;

  for (let i=0;i<lent;i++) {
    let date = new Date();
    date.setSeconds(0);
    date.setHours(10+i/4);
    date.setMinutes(i%4*15);
    const dateStr = date.toLocaleTimeString(['fr'], {
      hour: 'numeric',
      minute: 'numeric',
    });

    if (date<currentDate && add15minutes(date)>currentDate) {
      let r = highlightOption;
      r["value"] = [dateStr,sampleData[i]];
      option.series[0].data.push(r);
    }
      else {
    option.series[0].data.push({'value': [dateStr,sampleData[i]]});
  }
  }
  

  return (<div style={{width: '100%', height: '100%', display: "flex", flexDirection: "column"}}>
  <h2>Ruuhkaennuste</h2>
  <h3>Traffic Estimate</h3>
  <BarChart style={{flexGrow: 1}}  option={option} />
  </div>
)
}
